import '@cta/frontend';

import '@campact/camper/core/CmprAccordion';

import './index.scss';

import AppBoot from '@cta/frontend/javascripts/app_boot';
import App from './app.vue';

import { installErrorHandler } from '@appsignal/stimulus';
import DescriptionController from '@cta/donate_call_component/controllers/description_controller';
import appsignal from '@cta/shared/appsignal';
import { Application } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

Rails.start();

const application = Application.start();
installErrorHandler(appsignal, application);
application.register('description', DescriptionController);

AppBoot.start(App);
